import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { CorrectionHistory } from '../model/correction-history';
import { RetournerDossier } from '../model/retourner-dossier';
import { AnnulerCorrection } from '../model/annuler-correction';
import { CorrigerDossier } from '../model/corriger-dossier';

@Injectable({
    providedIn: 'root'
  })
  export class CorrectionHistoryService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    mesDossiersACorriger(username) 
    {
        return this._restClientService.load<CorrectionHistory[]>('correction-history/mes-dossiers-a-corriger'
        +'?username='+username);
    }
    
    mesDemandesDeCorrection(username) 
    {
        return this._restClientService.load<CorrectionHistory[]>('correction-history/mes-demandes-de-correction'
        +'?username='+username);
    }
    
    retourner(retournerDossier : RetournerDossier) {
        return  this._restClientService.save<void>('correction-history/retourner', retournerDossier);
    }
      
    annuler(annulerCorrection : AnnulerCorrection) {
        return  this._restClientService.save<void>('correction-history/annuler', annulerCorrection);
    }
      
    corriger(corrigerDossier : CorrigerDossier) {
        return  this._restClientService.save<void>('correction-history/corriger', corrigerDossier);
    }
      
    getCorrectionHistoryById(correctionId) 
    {
        return this._restClientService.load<CorrectionHistory>('correction-history/find-by-id/'+correctionId);
    }
    

}      

    